class Controller {
  constructor($mdDialog, rideName) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.rideName = rideName;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide(this.selected);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/actionListTable/assignCaptainDialog/assignCaptainDialog.controller.js